import { Component, Input, OnInit } from '@angular/core';
import { ENDPOINTS } from '@app/core/constants/endpoints';
import { WindowRefService } from '@app/core/services/helpers/window-ref.service';
import { EMPTY_STATE_IMAGE } from '@app/shared/constants/empty-state';
import { EMPTY_STATE_TYPE } from '@app/shared/enum/empty-state';

interface HelpCenterLink {
    display: boolean;
    customArticleUrl?: string;
}

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    standalone: false,
})
export class EmptyStateComponent implements OnInit {
    @Input() type: EMPTY_STATE_TYPE;
    @Input() helpCenterLink: HelpCenterLink;

    imageSrc = '';

    constructor(private windowRefService: WindowRefService) {}

    ngOnInit(): void {
        if (this.type != null) {
            this.imageSrc = EMPTY_STATE_IMAGE.get(this.type);
        }
    }

    openHelpCenter(): void {
        const url = this.helpCenterLink.customArticleUrl ?? ENDPOINTS.helpCenter.base;
        this.windowRefService.window.open(url, '_blank');
    }
}
